module.exports = __webpack_public_path__ + "static/img/shouyequesheng.da6ab378.svg";